import {
    IonButton,
    IonIcon
} from '@ionic/react';
import React, { useState } from 'react';
import { menuController } from '@ionic/core/components';
import { menu } from 'ionicons/icons';
import './OpenMenuButton.css';

const OpenMenuButton: React.FC = () => {

    const [menuEn, setMenuEn] = useState<boolean>(false);
    menuController.isEnabled().then((result) => {
      setMenuEn(result);  
    });
  
  return menuEn ? (
        <div/>
    ) : (
        <IonButton onClick={async () => {await menuController.enable(true);setMenuEn(true)}}>
        <IonIcon icon={menu}/>
        </IonButton>
    );
        
};

export default OpenMenuButton;
